import { ParkingStatuses } from '@aggregator/core';
import { DECIMAL_MASK, enumToDescriptedArray, ONLY_NUMBERS_MASK, TIME_MASK } from '@shared/core';
import { FormFieldType, FormGroupDirectionType, IFormGroupConfig } from '@shared/ui';

export const parkingFormConfig = <IFormGroupConfig>{
  type: FormFieldType.GROUP,
  fields: {
    // name: {
    //   type: FormFieldType.INPUT,
    //   label: 'Название:',
    //   placeholder: 'Введите название',
    //   required: true,
    // },
    address: {
      type: FormFieldType.INPUT,
      label: 'Адрес:',
      placeholder: 'Введите Адрес',
      required: true,
    },
    externalId: {
      type: FormFieldType.INPUT,
      label: 'Внешный ID:',
      placeholder: 'Введите ID',
      required: true,
    },
    row1: {
      type: FormFieldType.GROUP,
      direction: FormGroupDirectionType.ROW,
      forWrapping: true,
      fields: {
        type: {
          type: FormFieldType.SELECT,
          label: 'Тип:',
          placeholder: 'Укажите тип',
          optionValueField: 'id',
          optionLabelField: 'name',
          requestUrl: 'parking-types',
        },
        category: {
          type: FormFieldType.SELECT,
          label: 'Категория',
          placeholder: 'Укажите категория',
          optionValueField: 'id',
          optionLabelField: 'name',
          requestUrl: 'categories',
        },
      },
    },
    // location: {
    //   type: FormFieldType.GROUP,
    //   direction: FormGroupDirectionType.ROW,
    //   fields: {
    //     x: {
    //       type: FormFieldType.INPUT,
    //       label: 'Широта (X):',
    //       placeholder: 'Введите широту',
    //       maskConfig: DECIMAL_MASK,
    //     },
    //     y: {
    //       type: FormFieldType.INPUT,
    //       label: 'Долгота (Y):',
    //       placeholder: 'Введите долготу',
    //       maskConfig: DECIMAL_MASK,
    //     },
    //   },
    // },
    workingHours: {
      type: FormFieldType.GROUP,
      direction: FormGroupDirectionType.ROW,
      fields: {
        open: {
          type: FormFieldType.INPUT,
          label: 'Рабочее время от:',
          placeholder: 'Введите время',
          maskConfig: TIME_MASK,
          required: true,
        },
        close: {
          type: FormFieldType.INPUT,
          label: 'Рабочее время до:',
          placeholder: 'Введите время',
          maskConfig: TIME_MASK,
          required: true,
        },
      },
    },
    row2: {
      type: FormFieldType.GROUP,
      direction: FormGroupDirectionType.ROW,
      forWrapping: true,
      fields: {
        totalSpots: {
          type: FormFieldType.INPUT,
          label: 'Количество мест:',
          placeholder: 'Введите количество',
          maskConfig: ONLY_NUMBERS_MASK,
        },
        // isPaid: {
        //   type: FormFieldType.CHECKBOX,
        //   label: 'Платная',
        // },
      },
    },
    row3: {
      type: FormFieldType.GROUP,
      direction: FormGroupDirectionType.ROW,
      forWrapping: true,
      fields: {
        status: {
          type: FormFieldType.SELECT,
          label: 'Статус:',
          placeholder: 'Укажите статус',
          options: enumToDescriptedArray(ParkingStatuses),
          optionLabelField: 'description',
          optionValueField: 'id',
        },
        priceForHour: {
          type: FormFieldType.INPUT,
          label: 'Цена за час:',
          placeholder: 'Введите цену',
          maskConfig: DECIMAL_MASK,
        },
      },
    },
  },
};
